<template>
	<v-menu
		offset-x
		right
		content-class="card-tip"
		max-width="250"
		nudge-top="35"
		nudge-right="10"
		transition="slide-x-transition"
		:open-on-hover="hover"
	>
		<template #activator="tooltip">
			<div class="v-icon" style="cursor: pointer">
				<fa-icon v-on="tooltip.on" :icon="icon" size="sm" />
			</div>
		</template>
		<v-card light>
			<v-card-title v-if="title" class="accent white--text py-2">
				<span class="subheading font-weight-medium">{{ title }}</span>
			</v-card-title>
			<v-card-text>
				<slot></slot>
			</v-card-text>
		</v-card>
	</v-menu>
</template>

<script>
export default {
	data: () => ({}),

	props: {
		title: {
			default: false
		},
		hover: {
			default: false
		},
		icon: {
			default: () => ["fal", "question-circle"]
		}
	}
};
</script>
